<template>
  <v-dialog
    fullscreen
    eager
    v-model="dialog"
    hide-overlay
    content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-container v-if="dialog">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          {{ $t('display/offer:overview.title') + ' \'' + this.offer.name + '\'' }}
        </h2>
        <v-row justify="space-around">
          <v-col cols="12" md="5">

            <!-- Customer -->
            <v-text-field
              outlined
              readonly
              v-model="customerName"
              :label="$t('common:customer')"
            />

            <!-- Name -->
            <v-text-field
              outlined
              readonly
              v-model="offer.name"
              :label="$t('common:name')"
            />

            <!-- Client -->
            <v-text-field
              outlined
              readonly
              v-model="offer.client"
              :label="$t('display/offer:edit.client')"
            />

            <!-- Created at -->
            <v-text-field
              outlined
              readonly
              v-model="offer.createdAt"
              :label="$t('common:created_at')"
            />

            <!-- Budget -->
            <v-text-field
              outlined
              readonly
              v-model="offer.budget"
              :label="$t('common:budget')"
            />

            <!-- Playouts -->
            <v-text-field
              outlined
              readonly
              v-model="offer.playouts"
              :label="$t('display/offer:edit.playouts')"
            />

            <!-- Regions -->
            <v-textarea
              outlined
              readonly
              v-model="regions"
              :label="$t('display/offer:edit.regions')"
            />

          </v-col>

          <v-col cols="12" md="5">

            <!-- Provision -->
            <v-text-field
              outlined
              readonly
              append-icon="%"
              v-model="offer.provision"
              :label="$t('display/offer:edit.provision')"
            />

            <!-- Discount -->
            <v-text-field
              outlined
              readonly
              append-icon="%"
              v-model="offer.discount"
              :label="$t('display/offer:edit.discount')"
            />

            <!-- Cost -->
            <v-text-field
              outlined
              readonly
              v-model="offer.cost"
              :label="$t('display/offer:edit.cost')"
            />

            <!-- Date start -->
            <v-text-field
              outlined
              readonly
              v-model="offer.dateStart"
              :label="$t('common:start-date')"
            />

            <!-- Date end -->
            <v-text-field
              outlined
              readonly
              v-model="offer.dateEnd"
              :label="$t('common:end-date')"
            />

            <!-- Tags -->
            <v-textarea
              outlined
              readonly
              v-model="tags"
              :label="$t('common:tags')"
            />

            <!-- Excluded elevators -->
            <v-textarea
              outlined
              readonly
              v-model="excludedElevators"
              :label="$t('display/offer:excluded-elevators')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card
              elevation="0"
              flat
              tile
              class="pl-3 pt-3 pb-md-3"
            >
              <DirtyConfirmButtonDialog
                ref="dirtyDialog"
                :btn-text="$t('buttons:back')"
                color="grey"
                :hideOverlay="true"
                :dialog-title="$t('dialog:dirty-save-btn-title')"
                :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                :button1-text="$t('dialog:dirty-save-btn-1-text')"
                :button2-text="$t('dialog:dirty-save-btn-2-text')"
                @clickedButton="dialog=false"
              />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';
import ElevatorService from '@/modules/display/services/elevator-service';
import SettingsService from '@/modules/display/services/settings-service';
import InfoService from "@/modules/core/services/info-service";
import Utils from '@/modules/core/services/utils';
import OfferService from "@/modules/display/services/offer-service";

export default {
  name: "OfferForm",
  components: {
    DirtyConfirmButtonDialog
  },
  data() {
    return {
      dialog: false,
      offer: null,
      tags: null,
      regions: null,
      playoutCost: null,
      excludedElevators: null,
      customerName: '',
      tagsOptions: [],
      elevatorOptions: []
    }
  },
  methods: {
    initialization(item) {
      this.tags = '';
      this.regions = '';
      this.excludedElevators = '';
      this.playouts = '';
      this.offer = Object.assign({}, item);

      let regionsFlag = !item.regions;
      if (!regionsFlag) {
        this.parseRegions(JSON.parse(item.regions));
      }

      this.customerName = this.getCustomerName();

      let excludedElevatorFlag = !item.excludedElevators;
      if(!excludedElevatorFlag) {
        this.parseExcludedElevators(item.excludedElevators);
      }

      let tags = !item.tags;
      if(!tags) {
        this.parseTags(item.tags);
      }

      //Budget
      if (this.offer.budget != null) {
        this.offer.playouts = Math.round(item.budget / this.playoutCost).toLocaleString();
      }

      //Provision
      if (this.offer.provision != null) {
        this.offer.provision = item.provision * 100;
      }

      //Discount
      if (this.offer.discount != null) {
        this.offer.discount = item.discount * 100;
      }

      if (this.offer.budget != null && this.offer.provision != null) {
        this.offer.cost = this.offer.budget * (1.0 - this.offer.provision / 100);
      }

      this.dialog = true;
    },
    initializationById(id) {
      OfferService.readFromAPI(id,
          (res) => {
            this.initialization(res.data);
          }
      )
    },
    parseRegions(regions) {
      this.regions = '';
      for (let i = 0; i < regions.length; i++) {
        if (regions[i].filter_flag == 1) {
          this.regions += this.$t('common:country') + ': ' + regions[i].country_name + "\n";
          continue;
        }

        let provinces = regions[i].provinces;
        for(let pIt = 0; pIt < provinces.length; pIt++) {
          if (provinces[pIt].filter_flag == 1) {
            this.regions += this.$t('common:province') + ': ' + provinces[pIt].province_name + "\n";
            continue;
          }

          let cities = provinces[pIt].cities;
          for(let cIt = 0; cIt < cities.length; cIt++) {
            this.regions += this.$t('common:city') + ': ' + cities[cIt] + "\n";
          }

        }

      }
    },
    parseExcludedElevators(elevators) {
      for(let i = 0; i < elevators.length; i++) {
        this.excludedElevators += this.getElevatorById(elevators[i]) + "\n";
      }
    },
    getElevatorById(id) {
      for(let i = 0; i < this.elevatorOptions.length; i++) {
        if (id === this.elevatorOptions[i].id) {
          return this.elevatorOptions[i].name;
        }
      }

      return '';
    },
    parseTags(tags) {
      for(let i = 0; i < tags.length; i++) {
        this.tags += this.getTagById(tags[i]) + "\n";
      }
    },
    getTagById(tagId) {
      for(let i = 0; i < this.tagsOptions.length; i++) {
        if (tagId == this.tagsOptions[i].id) {
          return this.tagsOptions[i].translatedName;
        }
      }

      return '';
    },
    getCustomerName() {
      return typeof this.offer.customer === 'object' &&  this.offer.customer !== null
        ? this.offer.customer.name : this.offer.customer;
    }
  },
  created() {
    InfoService.readOptionsByUrl('display/tag',
      (response) => {
        this.tagsOptions = response;
      }
    );

    ElevatorService.readAllIdName(
      (response) => {
        for (var i = 0; i < response.data.length; i++) {
          this.elevatorOptions.push({id: response.data[i][0], name: response.data[i][1]});
        }
      },
      (error) => {
        this.$logger.error("Error at InfoService.readEnum: " + error);
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:elevator_plural')}));
      }
    );

    SettingsService.readFromAPI('PLAYOUT_COST',
      (response) => {
        this.playoutCost = response.data.value;
      }
    )
  }
}

</script>
